exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".separatorNotice{background-color:#512e6f;height:60px}.message{font-size:large;color:#000}.pickers{width:100%}.date-picker-notice,.pickers{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.date-picker-notice{font-size:1.2em;display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);

// exports
